import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetFinanceTradesService } from "@/features/accounts/finance/services/get-trades-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetFinanceTradesResponseModel } from "@/features/accounts/finance/services/get-trades-model";


export const useGetFinanceTrades = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getFinanceTradesService = new GetFinanceTradesService();

  // 銀行明細一覧取得
  const getFinanceTrades = async (
    accountGroupId: string,
    financeAccountId: string,
    financeId: string,
    industryCode: string,
    companyCode: string,
    startDate?: string,
    endDate?: string,
  ) :Promise<GetFinanceTradesResponseModel[]> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getFinanceTradesService.getFinanceTrades({
        account_group_id:  accountGroupId,
        finance_account_id: financeAccountId,
        finance_id: financeId,
        industry_code: industryCode,
        company_code: companyCode,
        ...(startDate !== undefined && { start_date: startDate }),
        ...(endDate !== undefined && { end_date: endDate }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getFinanceTrades:", error);
      throw error;
      // return [];
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getFinanceTrades: errorHandledAsync(getFinanceTrades, setError),
  };
};
